import { IMenuItem } from '../../models/menu.model';

/**
 * Menu configuration for Loss Adjuster Desk.
 * Contains menu items for compliance and infraction management.
 */
export const assetMenu: IMenuItem = {
  label: `Asset`,
  icon: 'fa fa-building',
  id: 'MID_ASSET_DESK',
  path: 'asset-desk',
  children: [
    { path: `motor`, label: `Motor`, icon: 'fa fa-car', id: 'MID_ASSET_DESK_MOTOR' },
    { path: `aircraft`, label: `Aircraft`, icon: 'fa fa-plane', id: 'MID_ASSET_DESK_AIRCRAFT' },
    { path: `water-vessel`, label: `Water Vessel`, icon: 'fa fa-ship', id: 'MID_ASSET_DESK_WATER_VESSEL' },
    { path: `building`, label: `Building`, icon: 'fa fa-house', id: 'MID_ASSET_DESK_BUILDING' },
    { path: `machinery`, label: `Machinery`, icon: 'fa fa-tools', id: 'MID_ASSET_DESK_MACHINERY' },
  ],
};
